export default __webpack_public_path__ + "static/media/info.f2e5d6a2.svg";